"use strict";

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var React = require("react"),
    React__default = _interopDefault(React),
    reactDom = require("react-dom"),
    PT = _interopDefault(require("prop-types")),
    uniqid = _interopDefault(require("uniqid")),
    browserOrNode = require("browser-or-node");

function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, t) {
  for (var r = 0; r < t.length; r++) {
    var o = t[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}

function _createClass(e, t, r) {
  return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e;
}

function _defineProperty(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

function _objectSpread(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {},
        o = Object.keys(r);
    "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
      return Object.getOwnPropertyDescriptor(r, e).enumerable;
    }))), o.forEach(function (t) {
      _defineProperty(e, t, r[t]);
    });
  }

  return e;
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && _setPrototypeOf(e, t);
}

function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function _setPrototypeOf(e, t) {
  return (_setPrototypeOf = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? _assertThisInitialized(e) : t;
}

function _toConsumableArray(e) {
  return _arrayWithoutHoles(e) || _iterableToArray(e) || _nonIterableSpread();
}

function _arrayWithoutHoles(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = new Array(e.length); t < e.length; t++) {
      r[t] = e[t];
    }

    return r;
  }
}

function _iterableToArray(e) {
  if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function isObject(e) {
  var t = typeof e;
  return null != e && ("object" == t || "function" == t);
}

var isObject_1 = isObject,
    commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
    freeGlobal = "object" == typeof commonjsGlobal && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal,
    _freeGlobal = freeGlobal,
    freeSelf = "object" == typeof self && self && self.Object === Object && self,
    root = _freeGlobal || freeSelf || Function("return this")(),
    _root = root,
    now = function now() {
  return _root.Date.now();
},
    now_1 = now,
    Symbol$1 = _root.Symbol,
    _Symbol = Symbol$1,
    objectProto = Object.prototype,
    hasOwnProperty = objectProto.hasOwnProperty,
    nativeObjectToString = objectProto.toString,
    symToStringTag = _Symbol ? _Symbol.toStringTag : void 0;

function getRawTag(e) {
  var t = hasOwnProperty.call(e, symToStringTag),
      r = e[symToStringTag];

  try {
    e[symToStringTag] = void 0;
    var o = !0;
  } catch (e) {}

  var n = nativeObjectToString.call(e);
  return o && (t ? e[symToStringTag] = r : delete e[symToStringTag]), n;
}

var _getRawTag = getRawTag,
    objectProto$1 = Object.prototype,
    nativeObjectToString$1 = objectProto$1.toString;

function objectToString(e) {
  return nativeObjectToString$1.call(e);
}

var _objectToString = objectToString,
    nullTag = "[object Null]",
    undefinedTag = "[object Undefined]",
    symToStringTag$1 = _Symbol ? _Symbol.toStringTag : void 0;

function baseGetTag(e) {
  return null == e ? void 0 === e ? undefinedTag : nullTag : symToStringTag$1 && symToStringTag$1 in Object(e) ? _getRawTag(e) : _objectToString(e);
}

var _baseGetTag = baseGetTag;

function isObjectLike(e) {
  return null != e && "object" == typeof e;
}

var isObjectLike_1 = isObjectLike,
    symbolTag = "[object Symbol]";

function isSymbol(e) {
  return "symbol" == typeof e || isObjectLike_1(e) && _baseGetTag(e) == symbolTag;
}

var isSymbol_1 = isSymbol,
    NAN = NaN,
    reTrim = /^\s+|\s+$/g,
    reIsBadHex = /^[-+]0x[0-9a-f]+$/i,
    reIsBinary = /^0b[01]+$/i,
    reIsOctal = /^0o[0-7]+$/i,
    freeParseInt = parseInt;

function toNumber(e) {
  if ("number" == typeof e) return e;
  if (isSymbol_1(e)) return NAN;

  if (isObject_1(e)) {
    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
    e = isObject_1(t) ? t + "" : t;
  }

  if ("string" != typeof e) return 0 === e ? e : +e;
  e = e.replace(reTrim, "");
  var r = reIsBinary.test(e);
  return r || reIsOctal.test(e) ? freeParseInt(e.slice(2), r ? 2 : 8) : reIsBadHex.test(e) ? NAN : +e;
}

var toNumber_1 = toNumber,
    FUNC_ERROR_TEXT = "Expected a function",
    nativeMax = Math.max,
    nativeMin = Math.min;

function debounce(e, t, r) {
  var o,
      n,
      i,
      a,
      l,
      s,
      u = 0,
      c = !1,
      f = !1,
      p = !0;
  if ("function" != typeof e) throw new TypeError(FUNC_ERROR_TEXT);

  function y(t) {
    var r = o,
        i = n;
    return o = n = void 0, u = t, a = e.apply(i, r);
  }

  function d(e) {
    var r = e - s;
    return void 0 === s || r >= t || r < 0 || f && e - u >= i;
  }

  function g() {
    var e = now_1();
    if (d(e)) return b(e);
    l = setTimeout(g, function (e) {
      var r = t - (e - s);
      return f ? nativeMin(r, i - (e - u)) : r;
    }(e));
  }

  function b(e) {
    return l = void 0, p && o ? y(e) : (o = n = void 0, a);
  }

  function _() {
    var e = now_1(),
        r = d(e);

    if (o = arguments, n = this, s = e, r) {
      if (void 0 === l) return function (e) {
        return u = e, l = setTimeout(g, t), c ? y(e) : a;
      }(s);
      if (f) return l = setTimeout(g, t), y(s);
    }

    return void 0 === l && (l = setTimeout(g, t)), a;
  }

  return t = toNumber_1(t) || 0, isObject_1(r) && (c = !!r.leading, i = (f = "maxWait" in r) ? nativeMax(toNumber_1(r.maxWait) || 0, t) : i, p = "trailing" in r ? !!r.trailing : p), _.cancel = function () {
    void 0 !== l && clearTimeout(l), u = 0, o = s = n = l = void 0;
  }, _.flush = function () {
    return void 0 === l ? a : b(now_1());
  }, _;
}

var debounce_1 = debounce;
browserOrNode.isBrowser && Promise.resolve(require("lightgallery.js")).then(function () {
  Promise.resolve(require("lg-fullscreen.js")).then(function () {}), Promise.resolve(require("lg-zoom.js")).then(function () {}), Promise.resolve(require("lg-thumbnail.js")).then(function () {}), Promise.resolve(require("lg-video.js")).then(function () {});
});

var lightgalleryContext = React.createContext(),
    addPrefix = function addPrefix(e) {
  return "react_lightgallery_".concat(e);
},
    LightgalleryProvider = function (e) {
  function t() {
    var e, r;

    _classCallCheck(this, t);

    for (var o = arguments.length, n = new Array(o), i = 0; i < o; i++) {
      n[i] = arguments[i];
    }

    return _defineProperty(_assertThisInitialized(r = _possibleConstructorReturn(this, (e = _getPrototypeOf(t)).call.apply(e, [this].concat(n)))), "groups", {}), _defineProperty(_assertThisInitialized(r), "gallery_element", React.createRef()), _defineProperty(_assertThisInitialized(r), "_forceUpdate", debounce_1(r.forceUpdate, 50)), _defineProperty(_assertThisInitialized(r), "getLgUid", function () {
      if (r.gallery_element.current) return r.gallery_element.current.getAttribute("lg-uid");
    }), _defineProperty(_assertThisInitialized(r), "registerPhoto", function (e, t, o) {
      r.groups = _objectSpread({}, r.groups, _defineProperty({}, t, [].concat(_toConsumableArray(r.groups[t] || []), [_objectSpread({}, o, {
        id: e
      })]))), r._forceUpdate();
    }), _defineProperty(_assertThisInitialized(r), "unregisterPhoto", function (e, t) {
      r.groups = _objectSpread({}, r.groups, _defineProperty({}, t, r.groups[t].filter(function (t) {
        return t.id !== e;
      }))), r._forceUpdate();
    }), _defineProperty(_assertThisInitialized(r), "destroyExistGallery", function () {
      "object" === ("undefined" == typeof window ? "undefined" : _typeof(window)) && window.lgData && window.lgData[r.getLgUid()] && window.lgData[r.getLgUid()].destroy(!0);
    }), _defineProperty(_assertThisInitialized(r), "openGallery", function (e, t) {
      if (r.gallery_element.current) {
        if (r.groups.hasOwnProperty(t)) {
          r.destroyExistGallery();
          var o = r.groups[t];
          lightGallery(r.gallery_element.current, _objectSpread({}, r.props.lightgallerySettings || {}, {
            videojs: !0,
            dynamic: !0,
            dynamicEl: o,
            index: o.findIndex(function (t) {
              return t.id === e;
            })
          }));
        } else console.error("Trying to open undefined group");
      } else console.error("Error on trying to open gallery; ref 'gallery_element' is not defined");
    }), r;
  }

  return _inherits(t, React.Component), _createClass(t, [{
    key: "componentWillUnmount",
    value: function value() {
      this.destroyExistGallery();
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.galleryClassName,
          r = void 0 === t ? addPrefix("gallery") : t,
          o = e.portalElementSelector,
          n = null;
      return browserOrNode.isBrowser && (n = o ? document.querySelector(o) : document.body), React__default.createElement(lightgalleryContext.Provider, {
        value: {
          registerPhoto: this.registerPhoto,
          unregisterPhoto: this.unregisterPhoto,
          openGallery: this.openGallery
        }
      }, this.props.children, browserOrNode.isBrowser && reactDom.createPortal(React__default.createElement("div", {
        className: r,
        ref: this.gallery_element
      }), n));
    }
  }]), t;
}();

_defineProperty(LightgalleryProvider, "propTypes", {
  children: PT.any,
  lightgallerySettings: PT.object,
  galleryClassName: PT.string,
  portalElementSelector: PT.string
});

var LightgalleryItem = function (e) {
  function t() {
    var e, r;

    _classCallCheck(this, t);

    for (var o = arguments.length, n = new Array(o), i = 0; i < o; i++) {
      n[i] = arguments[i];
    }

    return _defineProperty(_assertThisInitialized(r = _possibleConstructorReturn(this, (e = _getPrototypeOf(t)).call.apply(e, [this].concat(n)))), "state", {
      id: uniqid()
    }), _defineProperty(_assertThisInitialized(r), "register", function () {
      r.context.registerPhoto(r.state.id, r.props.group, {
        iframe: !!r.props.isVideo,
        src: r.props.src,
        thumb: r.props.src,
        subHtml: r.props.subHtml || "",
        downloadUrl: r.props.downloadUrl || ""
      });
    }), _defineProperty(_assertThisInitialized(r), "unregister", function () {
      r.context.unregisterPhoto(r.state.id, r.props.group);
    }), _defineProperty(_assertThisInitialized(r), "open", function () {
      r.context.openGallery(r.state.id, r.props.group);
    }), r;
  }

  return _inherits(t, React.Component), _createClass(t, [{
    key: "componentDidMount",
    value: function value() {
      this.register();
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.unregister();
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.itemClassName,
          r = void 0 === t ? addPrefix("item") : t,
          o = e.children;
      return React__default.createElement("div", {
        className: r,
        onClick: this.open
      }, o);
    }
  }]), t;
}();

_defineProperty(LightgalleryItem, "propTypes", {
  children: PT.any,
  group: PT.string.isRequired,
  src: PT.string.isRequired,
  subHtml: PT.oneOfType([PT.string, PT.object]),
  downloadUrl: PT.string,
  itemClassName: PT.string
}), _defineProperty(LightgalleryItem, "contextType", lightgalleryContext), exports.LightgalleryItem = LightgalleryItem, exports.LightgalleryProvider = LightgalleryProvider;